import React from 'react'
import { withRouter } from 'react-router-dom'

import Moment from 'moment'

import FAIcon from '../FAIcon'

import 'react-big-calendar/lib/sass/styles.scss'
import './CalendarEventComponent.scss'

const CalendarEventComponent = ({ event, history }) => {
  if (!event) return null
  const isDayInPast = Moment.utc(event.end) < Moment.utc()
  const isOverdue = event.type === 'Task' && !event.isComplete && Moment.utc(event.start) < Moment.utc()

  let containerClass = 'calendar-event-component-container d-flex align-items-center justify-content-between w-100'
  if (event.type === 'Task') {
    if (event.isComplete) containerClass += ' task-event-completed'
    else if (isOverdue) containerClass += ' task-overdue'
    else containerClass += ' task-event'
  } else {
    containerClass += ' appointment-event'
  }

  const icon = event.type === 'Task' ? 'calendar-check' : 'calendar-day'

  const handleDuplicateClick = e => {
    e.preventDefault()
    e.stopPropagation()
    if (!history) return
    const fromPath = `${history.location.pathname}${history.location.search || ''}`
    if (event.type === 'Appointment' && event.caseNumber && event.id) {
      history.push({
        pathname: `/cases/${event.caseNumber}/appointments`,
        search: `?duplicateFrom=${event.id}`,
        state: {
          duplicateAppointment: event.resource,
          from: fromPath,
        },
      })
    } else if (event.type === 'Task' && event.id) {
      if (event.caseNumber) {
        history.push({
          pathname: `/cases/${event.caseNumber}/tasks`,
          search: `?duplicateFrom=${event.id}`,
          state: {
            duplicateTask: event.resource,
            from: fromPath,
          },
        })
      } else {
        history.push({
          pathname: `/tasks/new`,
          search: `?duplicateFrom=${event.id}`,
          state: {
            duplicateTask: event.resource,
            from: fromPath,
          },
        })
      }
    }
  }

  return (
    <div className={containerClass}>
      <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: 0 }}>
        <FAIcon name={icon} className={`mr-1 flex-shrink-0 ${isDayInPast ? 'text-muted' : ''}`} />
        {event.isComplete && <span className="task-complete-check mr-1 flex-shrink-0">&#10003;</span>}
        <div className="event-content-container flex-grow-1" style={{ minWidth: 0, paddingRight: '4px' }}>
          <p className={`event-title mb-0 ${isDayInPast ? 'grayed-text' : ''}`}>{event.title}</p>
        </div>
      </div>
      {(event.type === 'Appointment' || event.type === 'Task') && event.id && (
        <button
          type="button"
          className="calendar-event-duplicate-btn flex-shrink-0 ml-1"
          title={`Duplicate this ${event.type.toLowerCase()}`}
          aria-label={`Duplicate this ${event.type.toLowerCase()}`}
          onClick={handleDuplicateClick}
        >
          <FAIcon name="copy" />
        </button>
      )}
    </div>
  )
}

export default withRouter(CalendarEventComponent)
